import { FC, useRef, useState } from 'react';
import { classes, stylesheet } from 'typestyle';
import { PlusIcon } from '@traceair/webapp-icons';
import { Blue100, Button, ButtonIcon, Gray20, typeCompact14Regular, White } from '@traceair/tds';
import { DocType } from '../../../types';
import { trackAction } from '../../../libs/analytics/ActionTracking';
import { useAppStore } from '../../../store/appStore';
import EditDocPopup from './EditDocPopup/EditDocPopup';
import { useClickOutside } from '../../../hooks';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

const MENU_ITEMS: DocType[] = [DocType.REMOTE_PILOT_CERTIFICATE, DocType.CERTIFICATE_OF_INSURANCE, DocType.TAX_FORM_W9];

const AddDocumentButton: FC = () => {
  const { smallerThanMedium } = useBreakpoint();
  const showWindow = useAppStore((state) => state.showWindow);
  const [isMenuShown, setIsMenuShown] = useState(false);

  const menuContainerRef = useRef(null);

  useClickOutside(menuContainerRef, () => setIsMenuShown(false));

  function handleAddDocClick(docType: DocType) {
    trackAction(`Add new ${docType} click`, null);
    showWindow(<EditDocPopup docType={docType} />);
  }

  function toggleMenu() {
    setIsMenuShown((i) => !i);
  }

  return (
    <div className={css.root} onClick={toggleMenu} ref={menuContainerRef}>
      {smallerThanMedium ? (
        <ButtonIcon style="secondary" icon={<PlusIcon color={Blue100} />} />
      ) : (
        <Button icon={<PlusIcon color={White} />} text="Upload new document" />
      )}

      {isMenuShown && (
        <div className={css.menu}>
          {MENU_ITEMS.map((item) => (
            <div
              key={item}
              onClick={() => handleAddDocClick(item)}
              className={classes(css.menuItem, typeCompact14Regular)}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const css = stylesheet({
  root: {
    position: 'relative',
    flexShrink: 0,
    zIndex: 2,
  },
  menu: {
    width: 200,
    position: 'absolute',
    top: 46,
    right: 0,
    padding: '4px 16px',
    backgroundColor: White,
    borderRadius: 12,
    boxShadow: '0px 3px 20px 0px rgba(0, 0, 0, 0.20), 0px 6px 40px 0px rgba(0, 0, 0, 0.40)',
  },
  menuItem: {
    minHeight: 40,
    padding: '4px 0',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    borderBottom: `1px solid ${Gray20}`,
    $nest: {
      '&:last-of-type': {
        borderBottom: 'unset',
      },
    },
  },
});

export default AddDocumentButton;
